import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import banner from "../../assets/hero_banner.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ProductCard from "../products/ProductCard";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import greenBanner from "../../assets/green_banner.webp";
import "../../styles/ReactToastify.css";

export default function Homepage({
  categories,
  products,
  events,
  handleCartUpdate,
  filterCategoryProducts,
  categoryProducts,
  reachedMax,
  setReachedMax,
}) {
  const [categoryItems, setCategoryItems] = useState([]);

  useEffect(() => {
    const filteredProducts = filterCategoryProducts("T-Shirts");
    setCategoryItems(filteredProducts);
  }, [categoryProducts]);

  // Shows side toast on adding to cart
  useEffect(() => {
    if (reachedMax !== 0) {
      if (reachedMax === 200) {
        // console.log("Showing toast 200");
        toast.success("Added to Cart!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (reachedMax === 500) {
        // console.log("Showing toast 500");
        toast.error("Already max quantity in cart", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setReachedMax(0);
    }
  }, [reachedMax]);

  return (
    <div>
      {/* Carousel */}
      <section className="">
        <div className="md:mx-[-32px] mx-[-16px]">
          <img src={banner} className="w-full h-[600px] object-cover" alt="" />
        </div>
        {/* <Carousel
          showThumbs={false}
          showStatus={false}
          autoPlay={true}
          interval={3000}
          stopOnHover={true}
          infiniteLoop={true}
        >
          <div>
            <img src={p800} className="rounded-2xl" alt="" />
          </div>
          {/* <div>
            <img
              src="https://source.unsplash.com/random/800x301"
              className="rounded-2xl"
              alt=""
            />
          </div> 
        </Carousel> */}
      </section>

      {/* Products */}
      <section className="mt-5 md:mt-10 bg-ambhosOrange py-5 md:py-10 mx-[-10px] px-[10px] rounded-xl md:rounded-none md:mx-[-32px] md:px-[32px]">
        <h1 className="text-xl md:text-3xl font-semibold text-white">
          Trending
        </h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {products?.map((product) => (
            <div key={product._id}>
              <ProductCard
                id={product._id}
                image={product?.images[0]}
                title={product.productName}
                brand={product.brandName}
                color={product.color}
                sizes={product.availableSize ? product.availableSize : []}
                rating={product.rating ? product.rating : ""}
                price={product.price}
                mrp={product.mrp}
                handleCartUpdate={handleCartUpdate}
              />
            </div>
          ))}
          <div>
            <div className="relative px-5 h-full rounded-lg bg-white flex justify-center items-center">
              <p className="text-2xl font-bold text-gray-400 cursor-pointer hover:scale-110 active:scale-95">
                <Link to="/store">
                  <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5 md:mt-10 md:mx-[-32px] md:pl-[32px]">
        <h1 className="text-xl md:text-3xl font-semibold">Categories</h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {categories.map((category) => (
            <Link
              key={category.name}
              to={`/store/products?category=${category.name}`}
            >
              <div>
                <div className="relative w-48 h-48 md:w-80 md:h-80 border rounded-lg bg-gray-200 flex justify-center items-center">
                  {/* <img src={category.image} alt="" /> */}
                  <img
                    src="https://picsum.photos/400"
                    className="rounded-lg"
                    alt=""
                  />
                  {/* <p className="absolute text-2xl font-bold text-gray-400">
                    {category.name}
                  </p> */}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Fitness Cover */}
      <section
        className="relative mt-10 h-96 py-10 mx-[-10px] md:mx-[-32px] rounded-xl md:rounded-none flex bg-gray-200 justify-center items-center bg-fitness bg-center bg-cover"
        style={{ backgroundImage: `url(${greenBanner})` }}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-60 rounded-xl"></div>
      </section>

      <section className="mt-10 md:mx-[-32px] md:pl-[32px]">
        <h1 className="text-2xl md:text-3xl font-semibold">Hot Deals</h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {categoryItems?.map((product) => (
            <div key={product._id}>
              <ProductCard
                id={product._id}
                image={product?.images[0]}
                title={product.productName}
                brand={product.brandName}
                color={product.color}
                sizes={product.availableSize ? product.availableSize : []}
                rating={product.rating ? product.rating : ""}
                price={product.price}
                mrp={product.mrp}
                handleCartUpdate={handleCartUpdate}
              />
            </div>
          ))}
        </div>
      </section>
      <section className="mt-10 md:mx-[-32px] md:pl-[32px]">
        <h1 className="text-2xl md:text-3xl font-semibold">Trendy Tshirts</h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {categoryItems?.map((product) => (
            <div key={product._id}>
              <ProductCard
                id={product._id}
                image={product?.images[0]}
                title={product.productName}
                brand={product.brandName}
                color={product.color}
                sizes={product.availableSize ? product.availableSize : []}
                rating={product.rating ? product.rating : ""}
                price={product.price}
                mrp={product.mrp}
                handleCartUpdate={handleCartUpdate}
              />
            </div>
          ))}
        </div>
      </section>
      <section className="mt-10 md:mx-[-32px] md:pl-[32px]">
        <h1 className="text-2xl md:text-3xl font-semibold">Shirts</h1>
        <div className="mt-5 flex space-x-5 overflow-scroll scrollbar-hide">
          {categoryItems?.map((product) => (
            <div key={product._id}>
              <ProductCard
                id={product._id}
                image={product?.images[0]}
                title={product.productName}
                brand={product.brandName}
                color={product.color}
                sizes={product.availableSize ? product.availableSize : []}
                rating={product.rating ? product.rating : ""}
                price={product.price}
                mrp={product.mrp}
                handleCartUpdate={handleCartUpdate}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Reviews from people */}
      {/* <section className="mt-16 bg-ambhosLiteOrange py-10 mx-[-10px] md:mx-[-32px] rounded-xl">
        <h1 className="pl-[10px] md:pl-[32px] text-2xl md:text-3xl italic font-semibold mb-10">
          See what other customers say...
        </h1>
        <div className="flex justify-center items-center">
          <div className="bg-white md:w-1/2 mx-5 md:mx-0 p-6 shadow rounded-lg text-gray-800">
            <div className="flex flex-col md:flex-row items-center md:space-x-5">
              <img
                src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/ColKrishanSingh.webp"
                alt="Col Krishan Singh"
                className="w-40 h-40 rounded-full mr-4"
              />
              <div className="mt-5 md:mt-0">
                <p className="font-semibold text-center md:text-left text-ambhosOrange text-lg">
                  Col Krishan Singh
                </p>

                <p className="text-justify">
                  I am Col Krishan Singh Badhwar, SM a delighted customer of
                  Ambhos. The sports wearable I purchased surpassed my
                  expectations. The quality and performance are outstanding,
                  leaving me thoroughly satisfied. I highly recommend Ambhos for
                  their exceptional products and excellent customer service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}
